module.exports = __webpack_public_path__ + "static/BT1-cut-205db0a5d9b0caf2749fdd3b7e24532b.jpg";